import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { ChatMode } from '../api/agentStep.model';

export const ChatModeSelectOptions: ISelectOption[] = [
  {
    id: ChatMode.appchat,
    value: ChatMode.appchat,
    displayName: ChatMode.appchat,
    filterType: FilterTypesEnum.ChatMode,
    categoryName: FilterTypesEnum.ChatMode.toString(),
  },
  {
    id: ChatMode.bizchat,
    value: ChatMode.bizchat,
    displayName: ChatMode.bizchat,
    filterType: FilterTypesEnum.ChatMode,
    categoryName: FilterTypesEnum.ChatMode.toString(),
  },
  {
    id: ChatMode.na,
    value: ChatMode.na,
    displayName: ChatMode.na,
    filterType: FilterTypesEnum.ChatMode,
    categoryName: FilterTypesEnum.ChatMode.toString(),
  },
];
